import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/CrearRegistroManualView',
    name: 'CrearRegistroManualView',
    component: () =>
      import(
        '../views/crear-registro-manual/CrearRegistroManualView.vue'),
    meta: {
      title: 'Crear Registro Manual',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('CrearRegistroManualView'),
      bread: {
        path: [
          'Registros',
        ],
      },
    },
  },
];
